import {ListItem, ListItemAvatar, ListItemText, Typography} from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import SteddiContainer from "../../General/SteddiContainer";
import SteddiInfoItem from "../../General/SteddiInfoItem";
import {CalendarDays, CalendarX, Info, User} from "lucide-react";
import useOrderState from "../../../stores/orderStore";
import DateHelpers, {monthNames} from "../../../helpers/DateHelpers";
import useAppState from "../../../stores/appStateStore";
import EnergiKonto from "../InfoItems/EnergiKonto";
import React from "react";
import Månedsbeløp from "../InfoItems/Månedsbeløp";

export default function ConfirmPage() {
  const state = useOrderState((state) => state)
  const setEditPaymentFreeMonths = useAppState((state) => state.setEditPaymentFreeMonths)

  return (
    <Grid2 container spacing={2}>
      <Grid2 xs={12}>
        <Typography>Sjekk at informasjonen nedenfor stemmer. Er alt ok, kan du gå videre til å signere med BankID. Da blir det gjennomført en kredittvurdering. Avtalen inngås når kredittvurderingen er
          godkjent og avtalen er signert.</Typography>
      </Grid2>
      <Grid2 xs={12}>
        <SteddiContainer padding={"sm"}>
          <EnergiKonto/>
        </SteddiContainer>
      </Grid2>
      <Grid2 xs={12}>
        <ListItem>
          <ListItemAvatar>
            <Info/>
          </ListItemAvatar>
          <ListItemText>Stemmer ikke adressen? Gå tilbake til Min side hos strømleverandøren din og velg riktig adresse der.</ListItemText>
        </ListItem>
      </Grid2>
      <Grid2 xs={12}>
        <SteddiContainer padding={"sm"}>
          <SteddiInfoItem title={`${state.customer?.firstName} ${state.customer?.lastName}`}
                          subtitle={`${state.customer?.invoiceAddress}, ${state.customer?.invoicePostNumber} ${state.customer?.invoicePostArea}`} icon={<User/>} bgColor={"secondary"}/>
        </SteddiContainer>
      </Grid2>
      <Grid2 xs={12}>
        <SteddiContainer padding="sm">
          <Månedsbeløp/>
        </SteddiContainer>
      </Grid2>
      <Grid2 xs={12}>
        <SteddiContainer padding="sm">
          <SteddiInfoItem title={"Første forfallsdato"} subtitle={DateHelpers.toDateString(state.firstPaymentDue)} icon={<CalendarDays/>} bgColor={"secondary"}/>
        </SteddiContainer>
      </Grid2>
      <Grid2 xs={12}>
        <SteddiContainer padding={"sm"}>
          <SteddiInfoItem button icon={<CalendarX/>} bgColor={"secondary"}
                          onClick={() => setEditPaymentFreeMonths(true)}
                          title={"Betalingsfri måned"}
                          subtitle={state.paymentFreeMonths.length > 0 ? state.paymentFreeMonths.map(m => monthNames[m - 1]).join(", ") : "Nei"}
          />
        </SteddiContainer>
      </Grid2>
    </Grid2>
  )
}